import { Typography } from '@mui/material';

import { FORM_FIELD_BOTTOM_LABEL_SX, FORM_FIELD_TOP_LABEL_SX } from '../styles';

import type { FormFieldTopLabelProps } from '../types';

export default function FormFieldTopLabel({
  htmlFor,
  label,
  placement = 'above',
  sx,
}: FormFieldTopLabelProps) {
  const placementSx = placement === 'below' ? FORM_FIELD_BOTTOM_LABEL_SX : FORM_FIELD_TOP_LABEL_SX;

  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      variant="body2"
      sx={[
        ...(Array.isArray(placementSx) ? placementSx : [placementSx]),
        ...(sx == null ? [] : Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {label}
    </Typography>
  );
}
